import React from 'react';
import { Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

import DateSelector from './SelectDate';
import PersonalDetails from './PersonalDetails';
import Medicare from './Medicare';
import Confirmation from './Confirmation';
import BookingRouteWrapper from '../../components/NewBooking/BookingRouteWrapper';
import BrandHeader from '../../components/common/BrandHeader';
import StepBar from '../../components/common/StepBar';
import {
  PageHead,
  PageShell,
  PageSubtitle,
  PageTitle,
} from '../../components/common/Card';
import {
  ROUTE_PREFIX_BOOKING,
  ROUTE_PREFIX_WORKFLOW_ID,
  ROUTES,
} from '../../constants/routes';
import {
  BOOKING_COUNTER_PREFIX,
  BOOKING_STEPS,
  STEP_MAPPING,
} from '../../constants/bookingConstants';

const BookingRoute = () => {
  const { step } = useSelector(({ booking }) => booking);
  const workflow = useSelector(({ workflow }) => workflow.data);
  const { stepNumber, title, subtitle } = STEP_MAPPING[step];
  const isNewAppointment = get(workflow, 'appointment.isNewAppointment', false);

  return (
    <>
      <BrandHeader />
      <PageShell>
        <StepBar
          steps={BOOKING_STEPS}
          currentStepNumber={stepNumber}
          counterPrefix={
            isNewAppointment
              ? BOOKING_COUNTER_PREFIX.NEW
              : BOOKING_COUNTER_PREFIX.REVIEW
          }
        />

        <PageHead>
          <PageTitle>{title}</PageTitle>
          {subtitle && <PageSubtitle>{subtitle}</PageSubtitle>}
        </PageHead>

        <Switch>
          <BookingRouteWrapper
            path={
              ROUTE_PREFIX_BOOKING +
              ROUTE_PREFIX_WORKFLOW_ID +
              ROUTES.SELECT_DATE
            }
          >
            <DateSelector />
          </BookingRouteWrapper>

          <BookingRouteWrapper
            path={
              ROUTE_PREFIX_BOOKING +
              ROUTE_PREFIX_WORKFLOW_ID +
              ROUTES.PERSONAL_DETAILS
            }
          >
            <PersonalDetails />
          </BookingRouteWrapper>

          <BookingRouteWrapper
            path={
              ROUTE_PREFIX_BOOKING + ROUTE_PREFIX_WORKFLOW_ID + ROUTES.MEDICARE
            }
          >
            <Medicare />
          </BookingRouteWrapper>

          <BookingRouteWrapper
            path={
              ROUTE_PREFIX_BOOKING +
              ROUTE_PREFIX_WORKFLOW_ID +
              ROUTES.CONFIRMATION
            }
          >
            <Confirmation />
          </BookingRouteWrapper>
        </Switch>
      </PageShell>
    </>
  );
};

export default BookingRoute;
